import { atom } from "recoil";

export const isBatchDiscountModal = atom<{
  isOpen: boolean;
  selectedIds: number[];
  onSuccess?: () => void;
}>({
  key: "isBatchDiscountModal",
  default: {
    isOpen: false,
    selectedIds: [],
    onSuccess: undefined,
  },
});
